////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const scheduledPromoManager = {
	getScheduledPromo: (
		filters = {},
		queryParams = { page: '0', size: '250', sort: 'createdDate', nameDir: 'asc' },
		idPromo = 0,
		toggledLines = false
	) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO,
		payload: {
			filters,
			queryParams,
			idPromo,
			toggledLines,
		},
	}),
	getScheduledPromoSuccess: (data, idPromo = 0, toggledLines = false) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO_SUCCESS,
		payload: {
			data,
			idPromo,
			toggledLines,
		},
	}),
	getScheduledPromoFailure: (error) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	getScheduledPromoUnit: (idPromo) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO_UNIT,
		payload: {
			idPromo,
		},
	}),
	getScheduledPromoUnitSuccess: (data) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO_UNIT_SUCCESS,
		payload: {
			data,
		},
	}),
	getScheduledPromoUnitFailure: (error) => ({
		type: ActionsTypes.GET_SCHEDULED_PROMO_UNIT_FAILURE,
		payload: {
			error,
		},
	}),
	getTransmissionPromo: (idCampaign) => ({
		type: ActionsTypes.GET_TRANSMISSION_PROMO,
		payload: {
			idCampaign,
		},
	}),
	getTransmissionPromoSuccess: (data) => ({
		type: ActionsTypes.GET_TRANSMISSION_PROMO_SUCCESS,
		payload: {
			data,
		},
	}),
	getTransmissionPromoFailure: (error) => ({
		type: ActionsTypes.GET_TRANSMISSION_PROMO_FAILURE,
		payload: {
			error,
		},
	}),
	getPromoCampaignNestedLines: (idCampaign, withTtc) => ({
		type: ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES,
		payload: {
			idCampaign,
			withTtc,
		},
	}),
	getPromoCampaignNestedLinesSuccess: (data) => ({
		type: ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES_SUCCESS,
		payload: {
			data,
		},
	}),
	getPromoCampaignNestedLinesFailure: (error) => ({
		type: ActionsTypes.GET_PROMO_CAMPAIGN_NESTED_LINES_FAILURE,
		payload: {
			error,
		},
	}),
	resetScheduledPromoManager: () => ({
		type: ActionsTypes.RESET_SCHEDULED_PROMO_MANAGER_ITEMS,
	}),
}

export default scheduledPromoManager
